import { isPlatformBrowser } from "@angular/common";
import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { OAuthErrorEvent, OAuthService, OAuthSuccessEvent } from "angular-oauth2-oidc";
import { Subscription } from "rxjs";
import { setTheme } from 'ngx-bootstrap/utils';
import { AuthService } from "./core/services/auth.service";
import { StorageService } from "./core/services/storage.service";
import { environment } from "environments/environment";


@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

    platform: any;
    oauthSubscription: Subscription;


    constructor(
        private translate: TranslateService, public router: Router,
        public authService: AuthService, public storageService: StorageService, private oauthService: OAuthService
    ) {
        setTheme('bs3');
        if (this.oauthService.discoveryDocumentLoaded) {
            this.onOidcModuleSetup();
        }
        this.oauthSubscription = this.oauthService.events.subscribe(event => {
            if (event instanceof OAuthSuccessEvent) {
                if (event.type === 'discovery_document_loaded')
                    this.onOidcModuleSetup();
                else if (event.type === 'session_changed')
                    this.sessionChanged();
            } else if (event instanceof OAuthErrorEvent) {
                this.oauthService.tryLogin();
            }
        });
    }

    async ngOnInit() {
        if (isPlatformBrowser(this.platform)) {
           this.translate.setDefaultLang('fr');
           this.translate.use('fr');
        }
        
    }
     
    // async isCrispEnabled(): Promise<boolean> {
    //     const settings = await this.storageService.getSettings();
    //     if(!settings || !settings.values.EnableCrisp){
    //         return false;
    //     }
    //     let crisp = settings.values.EnableCrisp.defaultValue.toLowerCase() == 'true';
    //     return crisp;
    // }
    private loadScript(env:string) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = 'window.$crisp=[];window.CRISP_WEBSITE_ID="bb948a60-045c-467a-9884-ff77159322af";(function(){d=document;s=d.createElement("script");s.src="https://client.crisp.chat/l.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();';
        script.innerHTML +=`$crisp.push(["set", "session:segments", [["EspaceClient-${env}"]]])`;
        const head = document.getElementsByTagName('head')[0];
        if (head !== null && head !== undefined) {
          document.head.appendChild(script);
        }
    }

    private sessionChanged() {
        this.storageService.clearStorage();
        this.storageService.writeRaw('redirect', window.location.pathname);
        this.storageService.writeRaw('queryString', window.location.search);
        window.location.href = "/deconnexion.html";
    }

    ngOnDestroy(): void {
        this.oauthSubscription.unsubscribe();
        this.storageService.resetStorage();
    }

    private onOidcModuleSetup() {
       const prevStateStored = localStorage.getItem("gs1-ecli-previous-state");
       const currentURL = window.location.href; 
       if(currentURL.indexOf("apim/connexion") === -1)
       {
         localStorage.removeItem("gs1-ecli-state-apim");
 
       }
       if(currentURL.indexOf("/standard") === -1)
       {
        localStorage.removeItem("tokenAdmin");
 
       }
       
       if(currentURL.indexOf("standard/details") === -1)
       {
         localStorage.removeItem("gs1-ecli-standard-state");
 
       }
       //#TODO: to Check
       //const segments = currentURL.split('/');

       /* if(segments.length > 3)
       {
         localStorage.removeItem("gs1-ecli-route-state");

       } */
       if(currentURL.indexOf("factures") === -1 || currentURL.indexOf("codes") === -1)
       {
         localStorage.removeItem("gs1-ecli-route-state");
 
       }
       if(prevStateStored) {
             localStorage.removeItem("gs1-ecli-previous-state");
             const prevState = JSON.parse(prevStateStored);
             this.router.navigateByUrl(prevState.url);
    }
       
       
 
 //to delete
   /*  if (this.storageService.getGS1Token() !== '' && prevStateStored) {
 
             localStorage.removeItem("gs1-ecli-previous-state");
             const prevState = JSON.parse(prevStateStored);
             this.router.navigateByUrl(prevState.url);
    }*/
         
     } 
}
